import { useTranslation } from 'react-i18next';
import helpers from '../../../Utils/helpers';
import type {
  BalanceItem,
  BalanceSubscription,
} from '../../../Containers/Customer/CustomerTransactions.types';

interface DrawerPackagesProps {
  subscriptions: BalanceSubscription[];
}

const money = (value?: number): string =>
  value !== undefined ? helpers.currencyFormatter(value) : '—';

const DrawerPackages = ({ subscriptions }: DrawerPackagesProps) => {
  const { t } = useTranslation();

  const renderDiscount = (item: BalanceItem): string =>
    item.discountAmount !== undefined && item.discountAmount !== 0
      ? helpers.currencyFormatter(item.discountAmount)
      : '—';

  return (
    <div className="d-flex flex-column gap-16">
      {subscriptions.map((sub) => (
        <div key={sub.id} className="border rounded-8 overflow-hidden">
          <div className="d-flex align-items-center justify-content-between p-16 font-weight-600">
            <span>{sub.name}</span>
            <span className="transactions-num">{money(sub.totalAmount)}</span>
          </div>
          <table className="table table-stripe mb-0">
            <thead>
              <tr>
                <th className="text-left">{t('customertransactions.service')}</th>
                <th className="text-right">{t('customertransactions.quantity')}</th>
                <th className="text-right">{t('customertransactions.unitPrice')}</th>
                <th className="text-right">{t('customertransactions.amount')}</th>
                <th className="text-right">{t('customertransactions.discount')}</th>
                <th className="text-right">{t('customertransactions.total')}</th>
              </tr>
            </thead>
            <tbody>
              {sub.items.map((item, index) => (
                <tr key={item.id ?? index}>
                  <td>{item.name}</td>
                  <td className="text-right transactions-num">{item.quantity ?? '—'}</td>
                  <td className="text-right transactions-num">{money(item.unitPrice)}</td>
                  <td className="text-right transactions-num">{money(item.amount)}</td>
                  <td className="text-right transactions-num">{renderDiscount(item)}</td>
                  <td className="text-right transactions-num">{money(item.totalAmount)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default DrawerPackages;
